import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import {
  gDriveContentFilesForSelectedCourseAtom,
  videoIdMapAtom,
} from './atoms'
import { useCallback } from 'react'
import { swapContentCodes } from './gDriveUtils'
import { ICourseNode } from '../../components/ingestion/IngestedTree'
import { transformAllNoteContent } from '../nodeTransformationHelpers'

export function useNoteNodeProcessing() {
  const swapFunc = useSwapContentCodes()
  return useCallback(
    (course: ICourseNode) => {
      const doSwap = swapFunc()
      const contentProcessing = [doSwap]
      const noteTransform = (c: string) => {
        return contentProcessing.reduce((acc, func) => {
          return func(acc)
        }, c)
      }
      transformAllNoteContent(course, noteTransform)
    },
    [swapFunc],
  )
}

function useSwapContentCodes() {
  const videoIdMap = useAtomValue(videoIdMapAtom)
  const gDrive = useAtomValue(gDriveContentFilesForSelectedCourseAtom)
  return useCallback(() => {
    return (c: string) =>
      swapContentCodes(c, {
        gDrive: gDrive ?? {},
        videoIdMap: videoIdMap ?? {},
      })
  }, [videoIdMap, gDrive])
}
